import React from 'react';
import type { TTextV2Theme } from '@alfa-bank/site-text-v2/src/models';
import type { TTheme as TLinkTheme } from '@alfa-bank/site-link/src/models';

import { ICONS } from './icons';
import styles from './styles/styles.css';
import type { TIcons } from './models';

const postfixes = ['б', 'Кб', 'Мб', 'Гб', 'Тб'];

/**
 * Показывает размер файла в сокращенном виде с пост-фиксом
 */
export const convertBytes = (bytes?: number | string | null): string => {
    const postfixesLength = postfixes.length - 1;

    let result: number = parseInt(`${bytes}`, 10);

    if ((!result && result !== 0) || result < 0) {
        return '';
    }

    let index = 0;

    while (result >= 1024 && index < postfixesLength) {
        result /= 1024;
        index += 1;
    }

    if (result >= 1000) {
        if (index >= postfixesLength) {
            return '';
        }

        result = 1;
        index += 1;
    }

    const postfix = postfixes[index];

    result = Math.round(result * 10) / 10;

    return `${result.toString().split('.').join(',')} ${postfix}`;
};

export const getIcon = (fileType?: TIcons, color?: string) => {
    const Icon = fileType && ICONS?.[fileType];

    const key = `key-${fileType || 'unknown'}`;

    return (
        <span key={key} className={styles.icon} data-test-id="file-link-icon">
            {Icon && <Icon color={color} />}
        </span>
    );
};

/**
 * Конвертирует тему компонента (наследуется от site-text-v2) в тему для компонента ссылки (site-link)
 * @param theme Тема
 * @returns Тема для ссылки
 */
export const convertTheme = (theme: TTextV2Theme): TLinkTheme => {
    switch (theme) {
        case 'black':
        case 'dark':
        case 'blue':
            return 'blue';
        case 'light':
        case 'white':
            return 'white';
    }
};
